module.exports = __webpack_public_path__ + "img/hatford-portrait.78d59769.jpg";